import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment-timezone';

@Pipe({
  name: 'localTime'
})
export class LocalTimePipe implements PipeTransform {

  constructor() { }

  transform(value: any, format: string = 'dd/MM/yyyy HH:mm:ss'): string {
    if (!value) return '';
    
    // Obtener la zona horaria del usuario logueado o usar America/Lima por defecto
    let tz = 'America/Lima';
    const currentUser = JSON.parse(localStorage.getItem("currentUser"));
    if (currentUser && currentUser.compania && currentUser.compania.pais && currentUser.compania.pais.zonaHoraria) {
        tz = currentUser.compania.pais.zonaHoraria;
    }
    
    // Convertir la fecha a la zona horaria destino y formatear
    // Moment tz convierte una fecha UTC o local a la zona destino
    // Para renderizar con DatePipe, le damos la fecha convertida sin la info de timezone (como un Date local manipulado) o simplemente usamos moment para formatear.
    // Usaremos moment directamente para formatear de acuerdo a lo que necesitemos
    // Pero si el formato es de DatePipe, habría que usarlo.
    // Mejor usamos moment().tz()
    
    // Convert DatePipe format to moment format (basic support)
    let momentFormat = format
        .replace(/dd/g, 'DD')
        .replace(/d/g, 'D')
        .replace(/MM/g, 'MM')
        .replace(/MMM/g, 'MMM')
        .replace(/yyyy/g, 'YYYY');
        
    return moment(value).tz(tz).format(momentFormat);
  }

}
